import { memo } from "react";
import { cn } from "../../tailwind-utils";

export interface KeyboardShortcutProps {
  keys: string[];
  className?: string;
}

export const KeyboardShortcut = memo(function KeyboardShortcut({
  keys,
  className,
}: KeyboardShortcutProps) {
  return (
    <div className={cn("flex items-center gap-0.5", className)}>
      {keys.map((key, index) => (
        <kbd
          className="inline-flex items-center justify-center min-w-6 h-6 px-1 text-xs font-medium leading-none text-gray-600 bg-gray-100 border border-gray-200 rounded shadow-sm"
          key={index}
        >
          {key}
        </kbd>
      ))}
    </div>
  );
});
